import React from 'react';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import classNames from 'classnames'
import { images } from '../../../../assets/image';
import { Button } from '@material-ui/core';
import { ColorPalette } from 'screens/addEditCustomScreen/widgetsCardData/horizontalWidgetCard/types';

const HorizontalWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const {
    widgetParams,
    defaultPaddings,
  } = props;

  const getColorPalette = () => {    
    if (widgetParams.colorPalette === ColorPalette.ERROR) {
      return styles.widgetContainerErrorTheme;
    }

    if (widgetParams.colorPalette === ColorPalette.PRIMARY) {
      return styles.widgetContainerPrimaryTheme;
    }

    if (widgetParams.colorPalette === ColorPalette.SURFACE) {
      return styles.widgetContainerSurfaceTheme;
    }

    if (widgetParams.colorPalette === ColorPalette.CONTRAST) {
      return styles.widgetContainerContrastTheme;
    }
    return styles.widgetContainerSurfaceTheme;
  }

  return (
    <div
      className={
        classNames([getColorPalette(), 
          `${widgetParams.isFullButton}` === 'true' ? styles.fullButtonLayout : null])}
      style={defaultPaddings}
    >
      <div className={classNames(styles.widgetImage)}>
      <img
        src={props.widgetParams.imageURL ? props.widgetParams.imageURL : images.placeHolder}
      />
      </div>
    
      <div
        className={classNames([styles.widgetData])}
        style={defaultPaddings}
      >
        <p
          className={classNames([styles.widgetTitle])}
        >
          {widgetParams.title}
        </p>
        <p
          className={classNames([styles.widgetDescription])}
        >
          {widgetParams.description}
        </p>
        <p
          className={classNames([styles.widgetDescription])}
        >
          {widgetParams.subTitle}
        </p>
        <div
          className={classNames([styles.actionGroup])}
        >
          <Button
            className={classNames([styles.button])}
          >
            {widgetParams.actionButtonTitle}
          </Button>
          {
            `${widgetParams.dismissButton}` === 'true'
            ? (
              <Button
                className={classNames([styles.dismissButton])}
              >
                {'Dismiss'}
              </Button>
            ) : null
          }
        </div>
      </div>
    </div>
  );
};

export default HorizontalWidget;
